module.exports = __webpack_public_path__ + "static/media/logo_white.ba1475d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/header/images/logo_white.png
// module id = 364
// module chunks = 4